/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrganizationUsersTileViewProps } from '@msdyn365-commerce-modules/account-management/src/modules/organization-users-tile/./organization-users-tile';

const OrganizationUsersTileView: React.FC<IOrganizationUsersTileViewProps> = props => {
    const { OrganizationUsersTile, heading, description, links } = props;
    const user = props.context.actionContext.requestContext.user;

    return (
        // @ts-ignore
        user.isB2b ? (
        <Module {...OrganizationUsersTile}>
            {heading}
            {description}
            {links}
            </Module>
        ) : null
    );
};

export default OrganizationUsersTileView;
